/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row4_SkillInputs */

const en_mk_model_row4_skill = /** @type {(inputs: Mk_Model_Row4_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search & summarize internal data`)
};

const id_mk_model_row4_skill = /** @type {(inputs: Mk_Model_Row4_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari & rangkum data internal`)
};

/**
* | output |
* | --- |
* | "Search & summarize internal data" |
*
* @param {Mk_Model_Row4_SkillInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row4_skill = /** @type {((inputs?: Mk_Model_Row4_SkillInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row4_SkillInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row4_skill(inputs)
	return en_mk_model_row4_skill(inputs)
});